import React, { useState, useEffect, Fragment } from "react";
import { Col, Container, Row, Table, Image } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import PropTypes from "prop-types";
import {
  get_subscription_details,
  admin_payout_vendor,
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import { useHistory } from "react-router";
import {
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { errorAlert, successAlert } from "../../../../function/alert";
import Alert from "react-s-alert";
import axios from "axios";
import { NEFT, serverApi } from "../../../../config/Keys";
import {
  CLEAR_LOADER,
  SET_LOADER,
  SINGLE_VENDOR_SETTLEMENT,
} from "../../../../store/types";
import { AdminTwilioCallingModal } from "../superAdminVendor/superAdminVendorTable/firstPageTable/AllVendorTableBody";
import SuperAdminChatWindowPopup from "../superAdminPendingVendors/SuperAdminChatWindowPopup";
import { SuperAdminSMS } from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import { SuperAdminNotification } from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import OrderViewModal from "../../../reusableComponents/OrderViewModal";
import { amApi } from "../../../../api/apiHelper";
import { ORDER_STATUS, ORDER_TYPE_NAME } from "../../../../enums/OrderEnums";
import ViewExpReqDetails from "../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpReqDetails";

const SuperadminPayoutDetails = (props) => {
  const [state, setState] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [bankData, setBankData] = useState([]);
  const [showTip, setShowTip] = useState(false);
  const [tipBankData, setTipBankData] = useState({});
  const [showBlock, setShowBlock] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const [reason, setReason] = useState("");
  const [blockData, setBlockData] = useState({ type: "", id: "", bType: "" });
  const [disabled, setDisabled] = useState(
    props.location && props.location.state && props.location.state.access
      ? props.location.state.access
      : false
  );
  const [orderDetail, setOrderDetail] = useState({});

  const [selectedIDs, setSelectedIDs] = useState([]);

  const blockReasons = ["Blocked for Payment", "Skip Account"];
  const unblockReasons = ["Free for Payment"];

  useEffect(() => {
    if (!props?.data?.vendor_id) {
      history.push("/superadminopenitemsettlement");
    }
  }, [props.data]);

  const onSuccessLoadBankDetails = (data) => {
    let subscriptionType = "casual_dining_status";

    if (data.casual_dining) {
      subscriptionType = "casual_dining_status";
    } else {
      subscriptionType = "fast_food_dining_status";
    }

    // if (data.casual_dining) {
    /// casual status check
    if (state === 0) {
      /// show added ordering bank account
      let orderBankAccount =
        data[subscriptionType].ordering.maintain_separate_bank.addedAccounts;

      for (let i = 0; i < orderBankAccount.length; i++) {
        if (
          orderBankAccount[i] &&
          orderBankAccount[i].account_purpose &&
          orderBankAccount[i].account_purpose === "TIPS"
        ) {
          setTipBankData(orderBankAccount[i]);
          setShowTip(true);
          break;
        }
      }

      for (let i = 0; i < orderBankAccount.length; i++) {
        if (
          orderBankAccount[i] &&
          orderBankAccount[i] &&
          orderBankAccount[i].account_purpose === "ORDERING"
        ) {
          setBankData(orderBankAccount[i]);
          break;
        }
      }
    } else if (state === 2) {
      if (data[subscriptionType].scan_and_pay.addedAccounts.length > 0) {
        setBankData(data[subscriptionType].scan_and_pay.addedAccounts[0]);
      }
    } else if (state === 1) {
      if (
        data[subscriptionType].event_management.offline_event.booking_enabled
          .addedAccounts.length > 0
      ) {
        setBankData(
          data[subscriptionType].event_management.offline_event.booking_enabled
            .addedAccounts[0]
        );
      }
    }
    setOpen(true);
  };

  const onSelect = (data) => {
    if (selectedIDs.some((ele) => ele === data)) {
      let newdata = selectedIDs.filter((ele) => ele !== data);
      setSelectedIDs(newdata);
      // let t = data.orderPayAmount + data.orderTipAmount + data.eventPayAmount + data.scanAndPayPayAmount;
      // setTotalAmount((parseFloat(totalAmount) - t).toFixed(2));
    } else {
      let newdata = [...selectedIDs, data];
      setSelectedIDs(newdata);
      // let t = data.orderPayAmount + data.orderTipAmount + data.eventPayAmount + data.scanAndPayPayAmount;
      // setTotalAmount((parseFloat(totalAmount) + t).toFixed(2));
    }
  };

  const handleShowClear = (data) => {
    if (data) {
      setSelectedIDs([data?._id]);
      setShowClear(true);
    } else if (selectedIDs.length) {
      setShowClear(true);
    } else {
      errorAlert("Select atleast on Request");
    }
  };

  const handleClear = async (data) => {
    let payload = {
      order_id: selectedIDs,
      type: "MANUAL",
      vendor_id: props?.data?.vendor_id?._id,
      restaurant_id: props?.data?.restaurant_id,
      manualDetails: data,
      payoutEndDate: props?.data?.endDate,
      payoutStartDate: props?.data?.startDate,
      payout_type: 0,
      total_amount: data.amount,
      settlement_amount: data.amount,
    };
    let manual = await amApi.post("/manualSettlement", payload);
    if (manual.status === 201) {
      let orders = orderData.filter(
        (ele) => !selectedIDs.includes(ele._id.toString())
      );
      setOrderData(orders);
      successAlert("Manual Settled Successfully");
      setSelectedIDs([]);
      setShowClear(false);
    } else {
      errorAlert("Error while settling");
    }
  };

  const handleClickOpen = (vendorId) => {
    setBankData({});
    setTipBankData({});
    setShowTip(false);
    const token = props.auth.user.accessToken;
    props.get_subscription_details(token, vendorId, onSuccessLoadBankDetails);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleView = (data) => {
    setShowOrderDetail(true);
    setOrderDetail(data);
  };

  const showView = () => {
    setShowOrderDetail(false);
    setOrderDetail({});
  };

  const calcTipsAndtOTAL = () => {
    let totalTipsAndAmount = 0;
    if (props && props.data && props.data.orderPayAmount) {
      totalTipsAndAmount = (
        props.data.orderPayAmount + props.data.orderTipAmount
      ).toFixed(2);
    }

    return totalTipsAndAmount;
  };

  const onSuccessPayout = (type) => {
    if (type === 0) {
      onClickPayOut("tip");
    } else {
      dispatch({ type: CLEAR_LOADER });
      history.push("/superadminopenitemsettlement");
    }
  };

  const onErrorPayout = (err) => {
    Alert.error(`<h4>${err ? err : "Something went wrong"} </h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onClickPayOut = (type) => {
    let amount =
      type === "total"
        ? parseFloat(props?.data?.orderPayAmount.toFixed(2))
        : type === "tip"
          ? parseFloat(props?.data?.orderTipAmount.toFixed(2))
          : type === "event"
            ? parseFloat(props?.data?.eventPayAmount?.toFixed(2))
            : type === "scan"
              ? parseFloat(props?.data?.scanAndPayPayAmount?.toFixed(2))
              : 0;
    if (bankData.fundId) {
      let formData = {};
      formData = {
        vendor_id: props.data.vendor_id._id,
        payout_type: type === "tip" ? 1 : state === 0 ? 0 : state === 1 ? 2 : 3,
        currency: "INR",
        settlement_account_details: {
          bankName: bankData.bankName,
          email: bankData.email,
          account_type: bankData.account_type,
          account_number: bankData.account_number,
          account_ifsc: bankData.account_ifsc,
          account_branch: bankData.account_branch,
          docs: bankData.docs,
          fundId: bankData.fundId,
          accountId: bankData.accountId,
        },
        settlement_amount: amount,
        total_amount: amount,
        payoutStartDate: new Date(props.data.startDate).getTime(),
        payoutEndDate: new Date(props.data.endDate).getTime(),
        totalEarnedComission:
          type === "tip"
            ? 0
            : state === 0
              ? props.data.orderComission
              : state === 1
                ? props.data.eventComission
                : 0,
      };

      if (state === 0) {
        formData.order_id = [];
        for (let i = 0; i < props.data.orders.length; i++) {
          if (
            !props?.data?.orders[i].blockSettlement &&
            !props?.data?.orders[i].settleOrderAmount
          ) {
            formData.order_id.push(props.data.orders[i]._id);
          }
        }
      } else if (state === 1) {
        formData.event_request_id = [];
        for (let i = 0; i < props.data.event_requests?.length; i++) {
          if (
            !props?.data?.event_requests[i].blockSettlement &&
            !props?.data?.orders[i].settleTipAmount
          ) {
            formData.event_request_id.push(props.data.event_requests[i]._id);
          }
        }
      } else if (state === 2) {
        formData.scan_and_pay_transactional_id = [];
        for (let i = 0; i < props.data.scan_and_pay?.length; i++) {
          if (!props?.data?.scan_and_pay[i].blockSettlement) {
            formData.scan_and_pay_transactional_id.push(
              props.data.scan_and_pay[i]._id
            );
          }
        }
      }
      const token = props.auth.user.accessToken;
      props.admin_payout_vendor(
        token,
        formData,
        onSuccessPayout,
        onErrorPayout
      );
    } else {
      onErrorPayout("Account Fund ID is missing/inappropriate");
    }
    // onErrorPayout('Settlement amount must be greater than "0"');
  };

  const showBlockPayment = (type, id, bType) => () => {
    setShowBlock(!showBlock);
    setBlockData({ type: type, id: id, bType: bType });
  };

  const submitPaymentBlock = async () => {
    try {
      let subObj = {};
      let query = null;
      let url = "";
      if (!reason) {
        alert("Select Reason");
      } else {
        if (blockData.type === "BLOCK") {
          subObj = {
            blockSettlement: true,
            blockReason: reason,
          };
        }
        if (blockData.type === "UNBLOCK") {
          subObj = {
            blockSettlement: false,
            blockReason: reason,
          };
        }
        if (blockData.bType === "ORDER") {
          query = "admin/orders";
          url = `${serverApi}/${query}/${blockData.id}`;
        } else if (blockData.bType === "EXP") {
          query = "admin/expRequest";
          url = `${serverApi}/${query}/${blockData.id}?vendor_id=${props?.data?.vendor_id?._id}`;
        } else if (blockData.bType === "SCAN") {
          query = "admin/transactional";
          url = `${serverApi}/${query}/${blockData.id}`;
        }
        const token = props.auth.user.accessToken;
        dispatch({ type: SET_LOADER });
        let data = await axios.patch(url, subObj, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        if (data.status === 200) {
          let newData = await axios.get(`${serverApi}/settlement`, {
            params: {
              status: "INDIVIDUAL",
              startDate: moment(props?.data?.startDate).format("YYYY-MM-DD"),
              endDate: moment(props?.data?.endDate).format("YYYY-MM-DD"),
              vendor: props?.data?.vendor_id?._id,
            },
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          });
          if (newData.status === 200) {
            let obj = { ...newData?.data?.data[0] };
            obj.startDate = props?.data?.startDate;
            obj.endDate = props?.data?.endDate;
            dispatch({ type: SINGLE_VENDOR_SETTLEMENT, payload: obj });
          }
        }
        dispatch({ type: CLEAR_LOADER });
        showBlockPayment("", "", "")();
      }
    } catch (err) {
      Alert.error(
        `<h4>${err ? err : "Something went worng, Try again later."} </h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      throw new Error(err);
    }
  };

  const [type, setType] = useState(0);
  const [showOrderDetail, setShowOrderDetail] = useState(false);

  const onTypeChange = (type) => {
    setType(type);
  };

  const totalComission = (orders, comissionCode) => {
    let newOrders = orders?.filter((ele) => !ele.blockSettlement);
    let orderTotal =
      newOrders?.reduce(
        (a, b) =>
          parseFloat(a) +
          parseFloat(
            b?.offerSettlement === "ADMIN"
              ? b.base_amount
              : b.base_amount - b.discount?.amount
          ),
        0
      ) || 0;
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100;
    return comission + gst;
  };

  function totalExpCommission(events, comissionCode) {
    let newOrders = events.filter((ele) => !ele.blockSettlement);
    let orderTotal = newOrders?.reduce(
      (a, b) => parseFloat(a) + parseFloat(b.paymentData?.totalAmount),
      0
    );
    let percent = parseFloat(comissionCode?.description || 0);
    let comission = (orderTotal * percent) / 100;
    let gst = (comission * 18) / 100;
    return comission + gst;
  }

  const [orderData, setOrderData] = useState(props?.data?.orders || []);

  useEffect(() => {
    if (!props?.data?.restaurant_name) {
      history.push("/superadminopenitemsettlement");
    }

    if (type === 0) {
      setOrderData(props?.data?.orders);
    } else if (type === 1) {
      let orders = props?.data?.orders.filter((ele) => ele.blockSettlement);
      setOrderData(orders);
    } else if (type === 2) {
      let orders = props?.data?.orders.filter((ele) => ele.blockSettlement);
      setOrderData(orders);
    } else if (type === 3) {
      // let orders = props?.data?.orders.filter(ele => !ele.settleOrderAmount);
      setOrderData([]);
    } else if (type === 4) {
      let orders = props?.data?.orders.filter((ele) => ele.blockSettlement);
      setOrderData(orders);
    }
  }, [type, props.data]);

  return (
    <React.Fragment>
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                backIcon
                link="/superadminopenitemsettlement"
                displayText="Back"
              />
              <Container fluid>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div>
                      <div className="super_admin_add_vendor mb-1">
                        <h5 className="main_header_text">Payout Details</h5>
                      </div>
                    </div>
                    <div className="mb-4 f14-400">
                      If User is using same accounts for Ordering and
                      Experiences still that will be initiated separately.
                    </div>
                  </div>
                  <div className="text-right" align="right">
                    <div className="f12-400 my-2">
                      Report Run Date: {moment().format("Do MMM, YYYY")}
                    </div>
                    <div className="f12-500">
                      Report Range Date :{" "}
                      {moment(props?.data?.startDate).format("ll")} -{" "}
                      {moment(props?.data?.endDate).format("ll")}
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-5">
                    <div className="d-flex align-items-center">
                      <div className="mr-3">
                        <img
                          //src="https://amealia.s3.amazonaws.com/1616416724030-media-desktop-candle-light-dining-at-radisson-hitech-city-2020-7-2-t-13-4-37.jpg"
                          src={props && props.data && props.data.logo_url}
                          width="100px"
                          alt="restaurant logo"
                          title="restaurant logo"
                        />
                      </div>
                      <div>
                        <div className="f20-700">
                          {props && props.data && props.data.restaurant_name}
                        </div>
                        <div className="f14-400">
                          {props && props.data && props.data.restaurant_address}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-5">
                    <div className="mr-3 f14-500 just">
                      Restaurant Number
                      <div className="p- 2 f12-400">
                        {props?.data.vendor_id?.country_code}{" "}
                        {props?.data?.vendor_id?.mobile_number}
                      </div>
                      <div className="d-flex align-items-center mt-2">
                        <AdminTwilioCallingModal
                          sendData={props?.data.point_of_contact}
                        />
                        <SuperAdminChatWindowPopup
                          data={props?.data}
                          text={"seating"}
                        />
                        {/* <SuperAdminSMS dataSend={props?.data.vendor_id} /> */}
                        <SuperAdminNotification
                          dataSend={props?.data.vendor_id}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div
                      className="f12-500 badge badge-warning p-2 mt-4"
                      style={{ borderRadius: "50px" }}
                    >
                      Open Items
                    </div>
                  </div>
                </div>
                <div className="mt-3 mb-3 p-2">
                  <hr />
                  {state === 0 && (
                    <div className="d-flex justify-content-between">
                      <div className="f12-500">
                        <div>
                          Amount <br />
                          to be Paid
                        </div>
                        <div className="mt-3">
                          ₹{" "}
                          {(
                            props?.data?.orderPayAmount +
                            props?.data?.orderTipAmount +
                            props.data?.orderComission
                          )?.toFixed(2) || 0}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Total <br />
                          Tip Amount
                        </div>
                        <div className="mt-3">
                          ₹ {props?.data?.orderTipAmount?.toFixed(2) || 0}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Current <br />
                          Settlement
                        </div>
                        <div className="mt-3">
                          ₹{" "}
                          {(
                            props?.data?.orderPayAmount +
                            props?.data?.orderTipAmount
                          )?.toFixed(2) || 0}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Taxes
                        </div>
                        <div className="mt-3">₹{" "}
                          {(
                            props?.data?.orderGSTAmount
                          )?.toFixed(2) || 0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Credit <br />
                          Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Debit
                          <br /> Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Reversal
                          <br /> Credit Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Reversal
                          <br /> Debit Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Disputed
                          <br /> Amount
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Payment
                          <br /> Gateway
                        </div>
                        <div className="mt-3">{NEFT}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Commission
                          <br />{" "}
                        </div>
                        <div className="mt-3">
                          ₹{" "}
                          {totalComission(
                            props?.data?.orders,
                            props?.data?.comissionCode
                          ).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  )}
                  {state === 1 && (
                    <div className="d-flex justify-content-between">
                      <div className="f12-500">
                        <div>
                          Amount <br />
                          to be Paid
                        </div>
                        <div className="mt-3">
                          ₹{" "}
                          {(
                            props?.data?.expPayAmount + props.data?.expComission + props?.data?.expGSTAmount
                          )?.toFixed(2) || 0}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Current <br />
                          Settlement
                        </div>
                        <div className="mt-3">
                          ₹ {(props?.data?.expPayAmount - props?.data?.expComission).toFixed(2)}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Taxes
                        </div>
                        <div className="mt-3">
                          ₹ {props?.data?.expGSTAmount?.toFixed(2) || 0}
                        </div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Credit <br />
                          Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Debit
                          <br /> Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Reversal
                          <br /> Credit Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Reversal
                          <br /> Debit Memo
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Disputed
                          <br /> Amount
                        </div>
                        <div className="mt-3">₹ {0}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Payment
                          <br /> Gateway
                        </div>
                        <div className="mt-3">{NEFT}</div>
                      </div>
                      <div className="f12-500">
                        <div>
                          Commission
                          <br />{" "}
                        </div>
                        <div className="mt-3">
                          ₹{" "}
                          {totalExpCommission(
                            props?.data?.exprequests,
                            props?.data?.comissionCode
                          ).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
                <div>
                  <div className="f14-700 mt-3  mb-3">Payable orders</div>
                  <div className="d-flex justify-content-between">
                    <div className="w-50">
                      <div className="d-flex">
                        <div
                          className={`mr-5 ml-3 ${state === 0 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(0)}
                          style={{ cursor: "pointer" }}
                        >
                          Orders
                        </div>
                        <div
                          className={`mr-5 ml-3 ${state === 1 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(1)}
                          style={{ cursor: "pointer" }}
                        >
                          Experiences
                        </div>
                        <div
                          className={`mr-5 ml-3 ${state === 2 && `selected-global-catalogue `
                            } f12-500`}
                          onClick={() => setState(2)}
                          style={{ cursor: "pointer" }}
                        >
                          Scan & Pay
                        </div>
                      </div>
                    </div>
                    <div>
                      {/* <RightMenuStatus onTypeChange={onTypeChange} type={type} /> */}
                      <Button
                        variant="danger"
                        className="btn-md mr-4 px-5"
                        onClick={() => handleShowClear(null)}
                      >
                        Manual Settlement
                      </Button>
                    </div>
                  </div>
                  <hr />
                </div>
                <div>
                  <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                    <Table>
                      <thead>
                        <TableHead
                          display={
                            state === 0 ? (
                              <tr>
                                <th style={{ width: "6%" }}></th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Order Type/ <br />
                                  Order ID
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Subtotal <br /> Of Items
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Discount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Net Order <br /> Value
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Taxes
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Surcharges
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Tip
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Amount <br />
                                  Paid
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Outgoing <br /> Charges + GST
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Commission <br />+ GST
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Amount to
                                  <br /> be Settled
                                </th>
                              </tr>
                            ) : null
                          }
                          displayevents={
                            state === 1 ? (
                              <tr>
                                <th
                                  style={{ width: "14%" }}
                                  className="f12-500"
                                >
                                  My Experience/
                                  <br />
                                  Experience ID
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Subtotal <br /> Ticket Amount
                                </th>
                                <th
                                  style={{ width: "12%" }}
                                  className="f12-500"
                                >
                                  Discount
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Net <br /> Value
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Amount Paid
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Outgoing <br /> charges + GST
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Commission <br />+ GST
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Amount to be
                                  <br />
                                  Settled
                                </th>
                              </tr>
                            ) : null
                          }
                          displayscanpay={
                            state === 2 ? (
                              <tr>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Payment Method/ <br />
                                  Transaction ID
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  User
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Total
                                  <br />
                                  Amount
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Tip
                                </th>
                                <th
                                  style={{ width: "10%" }}
                                  className="f12-500"
                                >
                                  Donation
                                </th>

                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                >
                                  Payment Status
                                  <br />
                                  /Date & Time
                                </th>
                                <th
                                  style={{ width: "15%" }}
                                  className="f12-500"
                                ></th>
                              </tr>
                            ) : null
                          }
                        />
                      </thead>
                      {/* {state === 0 &&
                          props &&
                          props.data &&
                          props.data.orders &&
                          props.data.orders.map((orderData, index) => (
                            <TableBody
                              orderData={orderData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))}
                        {state === 1 &&
                          props &&
                          props.data &&
                          props.data.event_requests &&
                          props.data.event_requests.map((eventData, index) => (
                            <TableBodyEvents
                              eventData={eventData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))}
                        {state === 2 &&
                          props &&
                          props.data &&
                          props.data.scan_and_pay &&
                          props.data.scan_and_pay.map((scanData, index) => (
                            <TableBodyScanAndPay
                              scanData={scanData}
                              key={index}
                              showBlockPayment={showBlockPayment}
                              loader={props.auth.loader}
                            />
                          ))} */}
                      {state === 0 &&
                        orderData.map((order, index) => (
                          <TableBody
                            orderData={order}
                            comissionCode={props?.data?.comissionCode}
                            key={index}
                            showBlockPayment={showBlockPayment}
                            loader={props.auth.loader}
                            handleView={handleView}
                            onSelect={onSelect}
                            selected={selectedIDs}
                            handleShowClear={handleShowClear}
                          />
                        ))}
                      {state === 1 &&
                        props &&
                        props.data &&
                        props.data.exprequests &&
                        props.data.exprequests.map((eventData, index) => (
                          <TableBodyEvents
                            eventData={eventData}
                            comissionCode={props?.data?.comissionCode}
                            key={index}
                            showBlockPayment={showBlockPayment}
                            loader={props.auth.loader}
                            handleShowClear={handleShowClear}
                          />
                        ))}
                      {state === 2 &&
                        props &&
                        props.data &&
                        props.data.scan_and_pay &&
                        props.data.scan_and_pay.map((scanData, index) => (
                          <TableBodyScanAndPay
                            scanData={scanData}
                            key={index}
                            showBlockPayment={showBlockPayment}
                            loader={props.auth.loader}
                          />
                        ))}
                    </Table>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </div>
        {showOrderDetail && (
          <OrderViewModal orderDetails={orderDetail} handleClose={showView} />
        )}
      </React.Fragment>
      {showBlock && (
        <PaymentBlock
          open={showBlock}
          showBlockPayment={showBlockPayment}
          blockReasons={blockReasons}
          setReason={setReason}
          reason={reason}
          unblockReasons={unblockReasons}
          submitPaymentBlock={submitPaymentBlock}
          blockData={blockData}
        />
      )}
      {showClear && (
        <ResetClear
          handleClose={() => setShowClear(false)}
          handleClear={handleClear}
        // setReason={setReason}
        // submitPaymentBlock={submitPaymentBlock}
        // blockData={blockData}
        />
      )}
    </React.Fragment>
  );
};

SuperadminPayoutDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  get_subscription_details: PropTypes.func.isRequired,
  admin_payout_vendor: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  data: state.superadminManageTransactions.single_vendor_settllement,
});

export default connect(mapStateToProps, {
  get_subscription_details,
  admin_payout_vendor,
})(SuperadminPayoutDetails);

const TableHead = (props) => {
  return (
    <>
      {props?.display}
      {props?.displayevents}
      {props?.displayscanpay}
    </>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [data, setData] = useState({});

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value =
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100;
    let gst = (value * 18) / 100;
    return value + gst;
  };

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100
    ).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2);
    return { fee: value, gst: gst };
  };

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges =
      (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation =
      data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount;
    let comission = orderComission(data, props?.comissionCode);
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission - (data?.gstTaxes || 0);
      return orderPayAmount;
    } else {
      return orderPayAmount;
    }
  };

  useEffect(() => {
    let gst = calcTaxes(props.orderData.gstAmount);
    let sur = calcTaxes(props.orderData.surCharges);
    let comission = orderComission(
      props.orderData,
      props?.comissionCode
    ).toFixed(2);
    let settle = amountToSettle(props.orderData).toFixed(2);
    let comissionDetails = orderComssionDetails(
      props.orderData,
      props?.comissionCode
    );
    setData({ gst, sur, comission, settle, comissionDetails });
  }, [props]);

  const handleView = () => {
    props.handleView(props.orderData);
  };

  // const calcRazorpayCharges = (data) => {
  //   let transDetails = data.transactionDetails;
  //   let razorpayAmount = 0;
  //   transDetails.forEach((ele) => {
  //     if (ele.paid && ele.method === "RAZORPAY" && ele.type === "PAYMENT") {
  //       razorpayAmount += ele.amount;
  //     }
  //   });
  //   if (data.donation?.amount && razorpayAmount) {
  //     razorpayAmount = razorpayAmount - data.donation?.amount;
  //   }
  //   razorpayAmount = (razorpayAmount * 2) / 100;
  //   let tax = (razorpayAmount * 18) / 100;

  //   return (razorpayAmount + tax).toFixed(2);
  // };
  // console.log('Order');
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.orderData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "6%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onSelect(props.orderData._id);
                    }}
                    checked={props.selected.some(
                      (ele) => ele === props.orderData._id
                    )}
                  />
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {ORDER_TYPE_NAME[props.orderData.order_type]}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹{" "}
                    {(
                      (props?.orderData?.base_amount || 0) -
                      (props?.orderData?.discount?.amount || 0)
                    ).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">₹{data?.gst}</div>
                    <InfoToolTip
                      title={"View the bifurcation of Taxes"}
                      data={props.orderData.gstAmount}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">₹ {data?.sur}</div>
                    <InfoToolTip
                      title={"View the bifurcation of Surcharges"}
                      data={props.orderData.surCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {(props?.orderData?.tip?.amount || 0).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(
                        parseFloat(
                          props?.orderData?.outgoingCharges?.fee || 0
                        ) +
                        parseFloat(props?.orderData?.outgoingCharges?.tax || 0)
                      ).toFixed(2)}
                    </div>
                    <InfoToolTip
                      title={"Outgoing gateway charges + GST"}
                      data={props.orderData.outgoingCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">₹ {data?.comission}</div>
                    <InfoToolTip
                      title={"Comission + 18% GST"}
                      data={data?.comissionDetails}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">₹ {data?.settle}</div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        {props.orderData.disputeId && (
                          <>
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">
                              Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </>
                        )}
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter)
                              .add(1, "day")
                              .format("MM-DD-YYYY")}
                            <br />
                            {/* {moment(props.orderData?.settleAfter).add(1, 'day').format("LT")} */}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">
                            {props?.orderData?.order_items?.length}
                          </div>
                        </div>
                        {props?.orderData?.delivery_partner === 2 && <div className="f12-500">
                          Delivery Charges <br />
                          User/Merchant/Amealio
                          <div className="mt-3">
                          ₹{props?.orderData?.deliveryCharges?.user} / ₹{props?.orderData?.deliveryCharges?.merchant} / ₹{props?.orderData?.deliveryCharges?.amealio}
                          </div>
                        </div>}
                        <div className="f12-500">
                          Order Status
                          <div className="mt-3">
                            {ORDER_STATUS[props?.orderData?.order_status]}
                          </div>
                        </div>
                        <div className="f12-500">
                          Refund Percentage
                          <div className="mt-3">
                            {props?.orderData?.deliveryCharges?.cancelRefund || "N/A"} 
                          </div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === "ADMIN"
                              ? "Amealio Offer"
                              : props?.orderData?.discount?.amount
                                ? "Merchant Offer"
                                : "N/A"}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3">
                            {" "}
                            {moment(props.orderData?.createdAt).format(
                              "MM-DD-YYYY"
                            )}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">
                            {props?.orderData?.blockReason || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Payout Payment Method</div>
                          <div className="mt-3">{NEFT}</div>
                        </div>
                        <div className="f12-500">
                          Payment Terms
                          <div className="mt-3">T2</div>
                        </div>
                        <div className="f12-500">
                          Incoming Gateway Charges + GST
                          <div className="d-flex align-items-center mt-3">
                            <div>
                              ₹{" "}
                              {(props?.orderData?.gatewayCharges?.fee || 0) +
                                (props?.orderData?.gatewayCharges?.tax || 0)}
                            </div>
                            <InfoToolTip
                              title={"Incoming gateway charges + Taxes"}
                              data={props.orderData.gatewayCharges}
                            />
                          </div>
                        </div>
                        <div className="f12-500">
                          Donation
                          <div className="mt-3">
                            ₹ {props?.orderData?.donation?.amount || 0}
                          </div>
                        </div>
                        <div className="f12-500">
                          Amount Received
                          <div className="mt-3">
                            ₹ {(props?.orderData?.total_amount).toFixed(2)}
                          </div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.orderData.disputeId && (
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>
                            )}
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={() =>
                                props.handleShowClear(props.orderData)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/Reset.svg")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              Reset <br /> to Clear
                            </div>
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={props.showBlockPayment(
                                props.orderData?.blockSettlement
                                  ? "UNBLOCK"
                                  : "BLOCK",
                                props.orderData._id,
                                "ORDER"
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/block.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              Block <br /> Payment
                            </div>
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={handleView}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/eye.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              View <br /> Transaction
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyEvents = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [data, setData] = useState({});

  const eventComission = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (event?.paymentData?.totalAmount * comission) / 100;
    let gst = (value * 18) / 100;
    return value + gst;
  };

  const eventComssionDetails = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((event?.paymentData?.totalAmount * comission) / 100).toFixed(
      2
    );
    let gst = ((value * 18) / 100).toFixed(2);
    return { fee: value, gst: gst };
  };

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges =
      (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation = Number(data?.paymentData?.donationAmount || 0);
    let payAmount = Number(data?.paymentData?.totalAmount);
    let comission = eventComission(data, props?.comissionCode);
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    } else {
      return orderPayAmount;
    }
  };

  useEffect(() => {
    let comission = eventComission(
      props.eventData,
      props?.comissionCode
    ).toFixed(2);
    let settle = amountToSettle(props.eventData).toFixed(2);
    let comissionDetails = eventComssionDetails(
      props.eventData,
      props?.comissionCode
    );
    setData({ comission, settle, comissionDetails });
  }, [props]);

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${props.eventData?.blockSettlement ? "#EE3A23" : "#06A200"
                    }`,
                }}
                onClick={showTr}
              >
                {/* // TODO Need to Maintain ENUM */}
                <td style={{ width: "13%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 text-break">
                      {props?.eventData?.experience?.name}
                      <br />
                      {props?.eventData?.experience?.expId}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      ₹ {props?.eventData?.paymentData?.amount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">-</div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      ₹ {props?.eventData?.paymentData?.totalAmount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      ₹ {props?.eventData?.paymentData?.totalAmount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(
                        parseFloat(
                          props?.eventData?.outgoingCharges?.fee || 0
                        ) +
                        parseFloat(props?.eventData?.outgoingCharges?.tax || 0)
                      ).toFixed(2)}
                    </div>
                    <InfoToolTip
                      title={"Outgoing gateway charges + GST"}
                      data={props?.eventData.outgoingCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">₹ {data?.comission}</div>
                    <InfoToolTip
                      title={"Comission + 18% GST"}
                      data={data?.comissionDetails}
                    />
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">{data.settle}</div>
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex ">
                        {props.eventData?.disputeId && (
                          <div className="col-3">
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">
                              Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </div>
                        )}
                        <div className="col-3">
                          <div className="f12-500">
                            Due Date
                            <div className="mt-3">
                              {moment(props.eventData?.settleAfter)
                                .add(1, "day")
                                .format("MM-DD-YYYY")}
                              <br />
                              {moment(props.eventData?.settleAfter)
                                .add(1, "day")
                                .format("LT")}
                            </div>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500">
                            Total PAX / <br /> Ticket No.
                            <div className="mt-3">
                              {props?.eventData?.adultCount ||
                                0 + props?.eventData?.kidsCount ||
                                0 + props?.eventData?.package?.adults ||
                                0 + props?.eventData?.package?.kids ||
                                0}{" "} PAX/
                              <br /> {props?.eventData?.requestId}
                            </div>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500">
                            Payment Block
                            <div className="mt-3">
                              {props?.eventData?.blockReason || "-"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Payout Payment Method</div>
                          <div className="mt-3">{NEFT}</div>
                        </div>
                        <div className="f12-500">
                          Payment Terms
                          <div className="mt-3">T2</div>
                        </div>
                        <div className="f12-500">
                          Incoming Gateway Charges + GST
                          <div className="d-flex align-items-center mt-3">
                            <div>
                              ₹{" "}
                              {(props?.eventData?.gatewayCharges?.fee || 0) +
                                (props?.eventData?.gatewayCharges?.tax || 0)}
                            </div>
                            <InfoToolTip
                              title={"Incoming gateway charges + Taxes"}
                              data={props.eventData.gatewayCharges}
                            />
                          </div>
                        </div>
                        <div className="f12-500">
                          Donation
                          <div className="mt-3">
                            ₹{" "}
                            {props?.eventData?.paymentData?.donationAmount || 0}
                          </div>
                        </div>
                        <div className="f12-500">
                          Amount Received
                          <div className="mt-3">
                            ₹ {props?.eventData?.paymentData?.totalAmount || 0}
                          </div>
                        </div>
                        <div className="f12-500">
                          Settlement Status
                          <div className="mt-3">
                            {props.eventData?.blockSettlement ? "Blocked" : "Cleared"}
                          </div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.eventData?.disputeId && (
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>
                            )}
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={() =>
                                props.handleShowClear(props.eventData)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/Reset.svg")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              Reset <br /> to Clear
                            </div>
                            <div
                              className="f10-400 m-2"
                              align="center"
                              onClick={props.showBlockPayment(
                                props.eventData?.blockSettlement
                                  ? "UNBLOCK"
                                  : "BLOCK",
                                props.eventData._id,
                                "EXP"
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={require("../../../../assets/images/iconButton/block.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              {props.eventData?.blockSettlement
                                ? "Un-block"
                                : "Block"}{" "}
                              <br /> Payment
                            </div>
                            <div className="f10-400 m-2" align="center">
                              <div>
                                <ViewExpReqDetails dataSend={props.eventData} overRideStyles={{ width: "35px", height: "35px" }} />
                                View <br /> Transaction
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

const TableBodyScanAndPay = (props) => {
  return (
    <React.Fragment>
      <tbody>
        <tr
          className="super_admin_all_users_table_body"
          style={{
            borderLeftWidth: "4px",
            borderLeftStyle: "solid",
            borderLeftColor: `${props.scanData?.blockSettlement ? "#EE3A23" : "#06A200"
              }`,
          }}
        >
          <td className="text-break" style={{ width: "15%" }}>
            <div className="f12-500">
              {props && props.scanData && props.scanData.transaction_type}
              <br />
              {props && props.scanData && props.scanData._id}
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center">
              <Image src={""} width="20px" fluid />
              <div className="f12-500 text-break">
                {props.scanData && props.scanData.user_id}
                {/* zomaland
                <br />
                1245789632
                <br />
                Ticket booked */}
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="f15-500">
              ₹ {props.scanData && props.scanData.amount}
            </div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.tip || 0}</div>
          </td>
          <td style={{ width: "10%" }}>
            <div className="f15-500">₹ {props?.scanData.donation || 0}</div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="badge badge-success">Success</div>
            <div className="f12-500">
              {moment(props.scanData && props.scanData.createdAt).format(
                "MM-DD-YYYY"
              )}
              <br />{" "}
              {moment(props.scanData && props.scanData.createdAt).format("LT")}
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div
              className="btn btn-danger"
              onClick={props.showBlockPayment(
                props.scanData?.blockSettlement ? "UNBLOCK" : "BLOCK",
                props.scanData._id,
                "SCAN"
              )}
            >
              {props.scanData?.blockSettlement
                ? "Unblock Payment"
                : "Block Payment"}
            </div>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};

const DialogForPayout = (props) => {
  return (
    <div>
      {props.tipBankData && props.disabled && (
        <div className="btn btn-danger" onClick={props.handleClickOpen}>
          Payout
        </div>
      )}
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" onClose={props.handleClose}>
          <div className="d-flex justify-content-between">
            <div>Payout Details</div>
            <div
              className="f18-500"
              onClick={props.handleClose}
              style={{ cursor: "pointer" }}
            >
              X
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Fragment>
            {props?.selectedTab === 0 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">Total Payable Amount</div>
                  <div className="f16-700 mr-4">
                    ₹{" "}
                    {(
                      parseFloat(props.tipAmount) +
                      parseFloat(props.orderAmount)
                    ).toFixed(2)}
                  </div>
                </div>
                <div className="d-flex mb-2">
                  <div className="f14-500 mr-4">
                    Total Tip Amount To be Paid
                  </div>
                  <div className="f14-500 mr-4">₹ {props.tipAmount}</div>
                </div>
                <div className="d-flex mb-2">
                  <div className="f14-500 mr-4">
                    Total Ordering Amount To be Paid
                  </div>
                  <div className="f14-500 mr-4">₹ {props.orderAmount}</div>
                </div>
              </>
            )}
            {props?.selectedTab === 1 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">Total Payable Event Amount</div>
                  <div className="f16-700 mr-4">
                    ₹ {parseFloat(props.eventAmount).toFixed(2)}
                  </div>
                </div>
              </>
            )}
            {props?.selectedTab === 2 && (
              <>
                <div className="d-flex mb-2">
                  <div className="f16-700 mr-4">
                    Total Payable Scan & Pay Amount
                  </div>
                  <div className="f16-700 mr-4">
                    ₹ {parseFloat(props.scanAmount).toFixed(2)}
                  </div>
                </div>
              </>
            )}
            {props.showTip ? (
              <>
                <hr />
                <div className="f14-500 mb-2">Account Details for Tips</div>
                <div className="row mb-2">
                  <div className="col-4 f12-700 ">Name on Account </div>
                  <div className="col-4 f12-700 ">Type of Account</div>
                  <div className="col-4 f12-700 ">Account Number</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 f12-500 ">
                    {props && props.tipBankData && props.tipBankData.bankName}
                  </div>
                  <div className="col-4 f12-500 ">
                    {" "}
                    {props &&
                      props.tipBankData &&
                      props.tipBankData.account_type}{" "}
                    Account
                  </div>
                  <div className="col-4 ">
                    <div className="f12-500 ">
                      {" "}
                      {props &&
                        props.tipBankData &&
                        props.tipBankData.account_number}
                    </div>
                    <div className="f10-400 ">Account Number</div>
                  </div>
                  <div className="col-4 ">
                    <div className="f12-500 ">
                      {" "}
                      {props &&
                        props.tipBankData &&
                        props.tipBankData.account_ifsc}
                    </div>
                    <div className="f10-400 ">IFSC Code</div>
                  </div>
                </div>
              </>
            ) : (
              <> </>
            )}
            <hr />
          </Fragment>
          {/* <div className="d-flex mt-2 mb-2">
            <div className="f14-500 mr-4">Current Settlement Amount</div>
            <div>
              ₹{" "}
              {props.selectedTab === 0
                ? props.orderAmount
                : props.selectedTab === 1
                ? props.eventAmount
                : props.scanAmount}
            </div>
          </div> */}
          <div className="f14-500 mb-2">
            {`Account Details for ${props?.selectedTab === 0
              ? "Ordering"
              : props?.selectedTab === 1
                ? "Experiences"
                : "Scan & Pay"
              }`}
          </div>
          <div className="row mb-2">
            <div className="col-4 f12-700 ">Name on Account </div>
            <div className="col-4 f12-700 ">Type of Account</div>
            <div className="col-4 f12-700 ">Account Number</div>
          </div>
          <div className="row mb-2">
            <div className="col-4 f12-500 ">
              {props && props.bankData && props.bankData.bankName}
            </div>
            <div className="col-4 f12-500 ">
              {props && props.bankData && props.bankData.account_type} Account
            </div>
            <div className="col-4 ">
              <div className="f12-500 ">
                {props && props.bankData && props.bankData.account_number}
              </div>
              <div className="f10-400 ">Account Number</div>
            </div>
            <div className="col-4 ">
              <div className="f12-500 ">
                {props && props.bankData && props.bankData.account_ifsc}
              </div>
              <div className="f10-400 ">IFSC Code</div>
            </div>
          </div>
          {props.selectedTab === 0 && !props.showTip && (
            <div className="text-warning f12-700">
              No bank account has been added for Tips so that amount will be
              credited to the same account of orders
            </div>
          )}
          <hr />

          <div
            className="btn btn-outline-secondary mr-2"
            style={{ width: "150px" }}
            onClick={props.handleClose}
          >
            Cancel
          </div>
          {/* {props.selectedTab === 0 && props.showTip ? (
            <div
              className="btn btn-outline-danger mr-2"
              style={{ width: "150px" }}
              onClick={() => props.onClickPayOut("tip")}
            >
              Pay for Tips
            </div>
          ) : (
            <> </>
          )} */}
          <div
            className="btn btn-danger"
            style={{ width: "150px" }}
            onClick={() => {
              props.onClickPayOut(
                props.selectedTab === 0
                  ? "total"
                  : props.selectedTab === 1
                    ? "event"
                    : "scan"
              );
            }}
          >
            Pay for{" "}
            {props.selectedTab === 0
              ? "Order"
              : props.selectedTab === 1
                ? "Event"
                : "Scan And Pay"}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const PaymentBlock = (props) => {
  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" onClose={props.handleClose}>
        <div className="d-flex justify-content-between">
          <div>Reason for Payment Block</div>
          <div
            className="f18-500"
            onClick={props.showBlockPayment("", "", "")}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="demo-simple-select-outlined-label">
              Select Reason
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={props.reason}
              onChange={(e) => props.setReason(e.target.value)}
              label="Select Reason"
              style={{ width: "100%" }}
            >
              {props.blockData?.type === "BLOCK"
                ? props.blockReasons.map((ele) => (
                  <MenuItem value={ele}>
                    <em>{ele}</em>
                  </MenuItem>
                ))
                : props.unblockReasons.map((ele) => (
                  <MenuItem value={ele}>
                    <em>{ele}</em>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <div
          className="btn btn-outline-secondary mr-2"
          style={{ width: "150px" }}
          onClick={props.showBlockPayment("", "", "")}
        >
          Cancel
        </div>
        <div
          className="btn btn-danger"
          style={{ width: "150px" }}
          onClick={props.submitPaymentBlock}
        >
          {props.blockData?.type === "BLOCK"
            ? "Confirm Block"
            : "Confirm Unblock"}
        </div>
      </DialogContent>
    </Dialog>
  );
};

const ResetClear = (props) => {
  const clearReasons = ["Payment done through Offline payments"];
  const [clearData, setClearData] = useState({
    reason: "",
    description: "",
    transaction: "",
    amount: 0,
  });

  const onSubmit = () => {
    if (clearData?.reason && clearData.description && clearData.transaction) {
      props.handleClear(clearData);
    } else {
      errorAlert("Please enter all the details");
    }
  };

  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" onClose={() => { }}>
        <div className="d-flex justify-content-between">
          <div>Reset to Cleared Items</div>
          <div
            className="f18-500"
            onClick={props.handleClose}
            style={{ cursor: "pointer" }}
          >
            X
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="demo-simple-select-outlined-label">
              Select Reason
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={clearData.reason}
              onChange={(e) =>
                setClearData({ ...clearData, reason: e.target.value })
              }
              label="Select Reason"
              style={{ width: "100%" }}
            >
              {clearReasons.map((ele) => (
                <MenuItem value={ele}>
                  <em>{ele}</em>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <TextField
            id="reference"
            variant="outlined"
            type="number"
            label="SettleAmount"
            name="settle amount"
            className={`w-100`}
            onChange={(e) =>
              setClearData({ ...clearData, amount: e.target.value })
            }
            value={clearData.amount}
          />
        </div>
        <div style={{ width: "100%", marginBottom: "8px" }}>
          <TextField
            id="reference"
            variant="outlined"
            label="Bank Reference Number"
            name="bank reference number"
            className={`w-100`}
            onChange={(e) =>
              setClearData({ ...clearData, transaction: e.target.value })
            }
            value={clearData.transaction}
          />
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <TextField
            id="reference"
            multiline
            rows={4}
            variant="outlined"
            label="Add Reason"
            name="addReason"
            className={`w-100`}
            onChange={(e) =>
              setClearData({ ...clearData, description: e.target.value })
            }
            value={clearData.description}
          />
        </div>
        <div
          className="btn btn-outline-secondary mr-2"
          style={{ width: "150px" }}
          onClick={props.handleClose}
        >
          Cancel
        </div>
        <div
          className="btn btn-danger"
          style={{ width: "150px" }}
          onClick={onSubmit}
        >
          Submit
        </div>
      </DialogContent>
    </Dialog>
  );
};

const StatusRightMenuArr = [
  { title: "All", value: 0 },
  { title: "Cleared", value: 1 },
  { title: "Open", value: 2 },
  { title: "Disputed", value: 3 },
  { title: "Blocked", value: 4 },
];

const RightMenuStatus = (props) => {
  return (
    <div className="d-flex">
      {StatusRightMenuArr.map((e) => (
        <div
          className={`mr-5 ml-3 ${props.type === e.value && `selected-global-catalogue `
            } f12-500`}
          onClick={() => props.onTypeChange(e.value)}
          style={{ cursor: "pointer" }}
          key={e.title}
        >
          {e.title}
        </div>
      ))}
    </div>
  );
};
